(function () {
  var root = document.querySelector('[data-bb-builder]');
  if (!root || root.dataset.ready) return;
  var vjson = root.querySelector('[data-variants]');
  if (!vjson) return;
  root.dataset.ready = '1';
  var variants = JSON.parse(vjson.textContent);
  var oils = [];
  try { var oj = root.querySelector('[data-oils]'); if (oj) oils = JSON.parse(oj.textContent); } catch (e) {}
  var shop = null;
  try { var sj = document.querySelector('[data-oilshop]'); if (sj) shop = JSON.parse(sj.textContent); } catch (e) {}
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CDN = 'https://cdn.shopify.com/s/files/1/1028/7867/5270/files/';
  function oilImg(title, w) { var t = String(title || '').toLowerCase(); if (t.indexOf('ylang') === 0) t = 'ylang'; return CDN + t + '.jpg?width=' + w; }
  var currency = 'EUR';
  try { currency = JSON.parse(root.querySelector('[data-money]').textContent); } catch (e) {}
  var fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: currency }); }
  catch (e) { fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency }); }
  var car = root.querySelector('[data-car]');
  var carCount = root.querySelector('[data-car-count]');
  var slides = car ? car.querySelectorAll('.bb-car__slide') : [];
  var colorRadios = root.querySelectorAll('input[name="color"]');
  var colorName = root.querySelector('[data-color-name]');
  var colorBox = root.querySelector('[data-colors]');
  var totalEl = root.querySelector('[data-total]');
  var errorEl = root.querySelector('[data-error]');
  var addBtn = root.querySelector('[data-add]');
  var cartBtn = root.querySelector('[data-addcart]');
  var giftBox = root.querySelector('[data-gift]');
  var giftList = root.querySelector('[data-gift-list]');
  var cardsBox = root.querySelector('.bb-cards');

  var st0 = document.createElement('style');
  st0.textContent = '.belt-aroma__img{width:34px;height:34px;border-radius:8px;object-fit:cover;flex:0 0 auto;background:#F4E4E0}.belt-aromas .belt-gift__list{grid-template-columns:repeat(2,1fr)}'
    + '.belt-oilpic{aspect-ratio:5/6;border-radius:20px;background:#F4E4E0;display:flex;align-items:center;justify-content:center;overflow:hidden}.belt-oilpic[hidden]{display:none}.belt-oilpic img{width:100%;height:100%;object-fit:cover;display:block}';
  document.head.appendChild(st0);

  /* Tercera tarjeta: aceite aromático suelto con sus 7 aromas y la imagen de cada uno */
  var aromaBox = null, aromaRadios = [], pic = null;
  if (shop && shop.variants && shop.variants.length && cardsBox) {
    var lab = document.createElement('label');
    lab.className = 'bb-card';
    lab.innerHTML = '<input type="radio" name="pack" value="__aceite"><span class="bb-card__ui"><span><span class="bb-card__name"></span><small class="bb-card__sub"></small></span><span class="bb-card__price"></span></span>';
    lab.querySelector('.bb-card__name').textContent = shop.name;
    lab.querySelector('.bb-card__sub').textContent = shop.sub;
    lab.querySelector('.bb-card__price').textContent = fmt.format(shop.price / 100);
    cardsBox.appendChild(lab);
    aromaBox = document.createElement('fieldset');
    aromaBox.className = 'bb-step belt-aromas';
    aromaBox.hidden = true;
    var lg = document.createElement('legend'); lg.textContent = shop.legend; aromaBox.appendChild(lg);
    var al = document.createElement('div'); al.className = 'belt-gift__list'; aromaBox.appendChild(al);
    var first = true;
    shop.variants.forEach(function (o) {
      var l = document.createElement('label');
      l.className = 'belt-gift__opt' + (first && o.available ? ' is-on' : '');
      var r = document.createElement('input');
      r.type = 'radio'; r.name = 'aroma'; r.value = o.id; r.disabled = !o.available;
      if (first && o.available) { r.checked = true; first = false; }
      l.appendChild(r);
      var im = document.createElement('img'); im.className = 'belt-aroma__img'; im.src = oilImg(o.title, 120); im.alt = ''; im.width = 34; im.height = 34; l.appendChild(im);
      var s = document.createElement('span'); s.textContent = o.title; l.appendChild(s);
      al.appendChild(l); aromaRadios.push(r);
      r.addEventListener('change', function () { aromaRadios.forEach(function (x) { x.parentNode.classList.toggle('is-on', x.checked); }); update(); });
    });
    var anchor = cardsBox.closest('fieldset');
    anchor.parentNode.insertBefore(aromaBox, anchor.nextSibling);
    if (car && car.parentNode) {
      pic = document.createElement('div'); pic.className = 'belt-oilpic'; pic.hidden = true;
      pic.innerHTML = '<img alt="" width="900" height="1080">';
      car.parentNode.appendChild(pic);
    }
  }
  function packRadios() { return root.querySelectorAll('input[name="pack"]'); }

  function checked(list) { for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i]; return null; }
  function goKey(key) {
    if (!car) return;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.key === key) { car.scrollTo({ left: i * car.clientWidth, behavior: 'smooth' }); return; }
    }
  }
  if (car && carCount) {
    car.addEventListener('scroll', function () {
      carCount.textContent = (Math.round(car.scrollLeft / (car.clientWidth || 1)) + 1) + ' / ' + slides.length;
    }, { passive: true });
  }
  function isOil() { var p = checked(packRadios()); return !!(p && p.value === '__aceite'); }
  function isDoble() { var p = checked(packRadios()); return !!(p && p.value === '__doble'); }
  function current() {
    var p = checked(packRadios()), c = checked(colorRadios);
    var o1 = (p && p.value !== '__doble' && p.value !== '__aceite') ? p.value : (variants[0] && variants[0].o1);
    var o2 = c ? c.value : null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].o1 === o1 && (o2 === null || variants[i].o2 === o2)) return variants[i];
    }
    return variants[0];
  }
  /* Qué foto toca según lo elegido: individual+color, pack doble+regalo */
  function keyFor() {
    if (isDoble()) return 'pack-regalo';
    var c = checked(colorRadios);
    var n = c ? String(c.value).toLowerCase() : 'rosa';
    return 'var-' + (n.indexOf('blanc') === 0 ? 'blanca' : 'rosa');
  }
  var giftRadios = [];
  if (giftBox && giftList && oils.length) {
    oils.forEach(function (o, i) {
      var l = document.createElement('label');
      l.className = 'belt-gift__opt' + (i === 0 ? ' is-on' : '');
      var r = document.createElement('input');
      r.type = 'radio'; r.name = 'regalo'; r.value = o.id; r.checked = i === 0; r.disabled = !o.available;
      var im = document.createElement('img'); im.className = 'belt-aroma__img'; im.src = oilImg(o.title, 120); im.alt = ''; im.width = 34; im.height = 34;
      var s = document.createElement('span'); s.textContent = o.title;
      l.appendChild(r); l.appendChild(im); l.appendChild(s); giftList.appendChild(l); giftRadios.push(r);
      r.addEventListener('change', function () {
        giftRadios.forEach(function (x) { x.parentNode.classList.toggle('is-on', x.checked); });
      });
    });
  }
  function gift() {
    if (!isDoble() || !giftRadios.length) return null;
    var g = checked(giftRadios);
    return g ? { id: parseInt(g.value, 10), quantity: 1, properties: { 'Regalo': 'Incluido con el pack doble' } } : null;
  }
  function oilSel() { var a = checked(aromaRadios); return a ? parseInt(a.value, 10) : null; }
  function oilObj() { var id = oilSel(); if (!shop || id === null) return null; for (var i = 0; i < shop.variants.length; i++) if (shop.variants[i].id === id) return shop.variants[i]; return null; }
  function update() {
    var v = current();
    if (!v) return;
    var p = checked(packRadios());
    var oil = isOil();
    if (oil) totalEl.textContent = fmt.format(shop.price / 100);
    else totalEl.textContent = fmt.format((isDoble() ? parseInt(p.dataset.doble, 10) : v.price) / 100);
    var c = checked(colorRadios);
    if (c && colorName) colorName.textContent = c.dataset.name;
    var okBuy = oil ? oilSel() !== null : v.available;
    addBtn.disabled = !okBuy;
    if (cartBtn) cartBtn.disabled = !okBuy;
    if (colorBox) colorBox.hidden = oil;
    if (aromaBox) aromaBox.hidden = !oil;
    if (giftBox) giftBox.hidden = !(isDoble() && giftRadios.length);
    if (pic) {
      pic.hidden = !oil;
      if (car) car.style.display = oil ? 'none' : '';
      [].forEach.call(root.querySelectorAll('.bb-arrow,.bb-thumbs,[data-car-count]'), function (el) { el.style.display = oil ? 'none' : ''; });
      if (oil) { var o = oilObj(); var im = pic.querySelector('img'); im.src = o ? oilImg(o.title, 900) : ''; im.alt = o ? o.title : ''; }
    }
    errorEl.hidden = true;
  }
  root.addEventListener('change', function (e) {
    var n = e.target && e.target.name;
    if (n === 'pack' || n === 'color') { update(); if (!isOil()) goKey(keyFor()); }
  });

  function lines() {
    if (isOil()) return [{ id: oilSel(), quantity: 1 }];
    var v = current();
    var items = [{ id: v.id, quantity: isDoble() ? 2 : 1 }];
    var g = gift();
    if (g) items.push(g);
    return items;
  }
  function fail(e) { errorEl.textContent = e.message; errorEl.hidden = false; addBtn.disabled = false; if (cartBtn) cartBtn.disabled = false; }
  function post(items) {
    return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'No se pudo añadir'); return d; }); });
  }
  function canBuy() {
    var v = current();
    if (isOil()) return oilSel() !== null;
    return !!(v && v.available);
  }

  addBtn.addEventListener('click', function () {
    if (!canBuy()) { errorEl.textContent = 'Esta opción no está disponible ahora mismo.'; errorEl.hidden = false; return; }
    addBtn.disabled = true;
    fetch(base + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } })
      .catch(function () {})
      .then(function () { return post(lines()); })
      .then(function () {
        if (root.dataset.destino === 'pago') { if (window.beltGoCheckout) window.beltGoCheckout(); else window.location.href = base + 'checkout'; }
        else window.location.href = base + 'cart';
      })
      .catch(fail);
  });
  if (cartBtn) cartBtn.addEventListener('click', function () {
    if (!canBuy()) { errorEl.textContent = 'Esta opción no está disponible ahora mismo.'; errorEl.hidden = false; return; }
    cartBtn.disabled = true;
    var go = window.beltCart ? window.beltCart.add(lines()) : post(lines()).then(function () { window.location.href = base + 'cart'; });
    go.then(function () { cartBtn.disabled = false; errorEl.hidden = true; }).catch(fail);
  });
  window.addEventListener('pageshow', function () { addBtn.disabled = false; update(); });
  if (!checked(packRadios()) && packRadios()[0]) packRadios()[0].checked = true;
  update();
})();
  /* Galería: flechas, miniaturas (escritorio), arrastrar con ratón y teclado */
  (function () {
    var car = document.querySelector('[data-car]');
    if (!car) return;
    var slides = car.querySelectorAll('.bb-car__slide');
    if (slides.length < 2) return;
    var wrap = car.parentNode;
    var st = document.createElement('style');
    st.textContent = '.bb-car{cursor:grab;touch-action:pan-x pan-y;overscroll-behavior-x:contain}.bb-car.is-drag{cursor:grabbing;scroll-snap-type:none!important;scroll-behavior:auto!important}.bb-car img{-webkit-user-drag:none;user-select:none}'
      + '.bb-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:38px;height:38px;border-radius:50%;border:0;background:rgba(255,255,255,.92);color:#3B1A25;font-size:20px;line-height:1;cursor:pointer;box-shadow:0 2px 10px rgba(59,26,37,.25);display:flex;align-items:center;justify-content:center}.bb-arrow[disabled]{opacity:.35;cursor:default}.bb-arrow--prev{left:8px}.bb-arrow--next{right:8px}'
      + '.bb-thumbs{display:flex;gap:8px;overflow-x:auto;margin:10px 0 0;padding:2px 2px 6px;scrollbar-width:thin}.bb-thumb{flex:0 0 64px;width:64px;height:64px;padding:0;border:2px solid transparent;border-radius:10px;overflow:hidden;background:#fff;cursor:pointer;opacity:.7}.bb-thumb img{width:100%;height:100%;object-fit:cover;display:block}.bb-thumb.is-on{border-color:#7A2E3F;opacity:1}';
    document.head.appendChild(st);
    function cur() { return Math.round(car.scrollLeft / (car.clientWidth || 1)); }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); car.scrollTo({ left: i * car.clientWidth, behavior: 'smooth' }); }
    function mk(cls, txt, label, fn) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bb-arrow ' + cls; b.textContent = txt; b.setAttribute('aria-label', label);
      b.addEventListener('click', fn); wrap.appendChild(b); return b;
    }
    var prev = mk('bb-arrow--prev', '‹', 'Foto anterior', function () { go(cur() - 1); });
    var next = mk('bb-arrow--next', '›', 'Foto siguiente', function () { go(cur() + 1); });
    var thumbs = document.createElement('div');
    thumbs.className = 'bb-thumbs';
    var tb = [];
    slides.forEach(function (s, i) {
      var im = s.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bb-thumb'; b.setAttribute('aria-label', 'Ver foto ' + (i + 1));
      var t = document.createElement('img'); t.src = im ? im.src.replace('width=900', 'width=160') : ''; t.alt = ''; b.appendChild(t);
      b.addEventListener('click', function () { go(i); });
      thumbs.appendChild(b); tb.push(b);
    });
    wrap.parentNode.insertBefore(thumbs, wrap.nextSibling);
    function sync() {
      var i = cur();
      prev.disabled = i <= 0; next.disabled = i >= slides.length - 1;
      tb.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
    }
    car.addEventListener('scroll', sync, { passive: true });
    sync();
    car.tabIndex = 0;
    car.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(cur() - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { go(cur() + 1); e.preventDefault(); }
    });
    var down = false, sx = 0, sl = 0, moved = false;
    car.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = car.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 4) { moved = true; car.classList.add('is-drag'); }
      if (moved) car.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) { car.classList.remove('is-drag'); go(cur()); }
    });
    window.addEventListener('resize', function () { go(cur()); });
  })();